
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculators/salary-calculator",
      function () {
        return require("private-next-pages/calculators/salary-calculator/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calculators/salary-calculator"])
      });
    }
  